<div class="order-history-quote-container" *ngIf="{orderHistory: orderHistory$ | async, deviceCart: deviceCart$ | async} as model">
    <div class="content">
        <div class="header">
            <div class="heading">{{ 'basket.orderInformation.headline' | translate }}</div>
        </div>
        <div class="body">
            <div class="detail">
                <div class="label">{{ 'order.history.info.invoiceNumber.headline' | translate }}</div>
                <div class="value" *ngIf="model.orderHistory.invoiceNumber else noData">{{ model.orderHistory?.invoiceNumber}}</div>
                <ng-template #noData>
                    <div class="value">
                        {{ 'basket.orderInformation.poNumber.noData' | translate }}
                    </div>
                </ng-template>
            </div>
            <div class="spacer"></div>
            <div class="detail">
                <div class="label">{{ 'order.history.info.invoiceDate.headline' | translate }}</div>
                <div class="value" *ngIf="model.orderHistory.invoiceDate else noData">{{model.orderHistory?.invoiceDate | date:'dd.MM.yyyy'}}</div>
                <ng-template #noData>
                    <div class="value">
                        {{ 'basket.orderInformation.poNumber.noData' | translate }}
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="body" [formGroup]="form">
            <div class="po-number">
                <div class="label">
                    <label>{{'basket.orderInformation.poNumber.headline' | translate}}</label>
                </div>
                <input
                        *ngIf="canEdit else noNumberRole"
                        type="text"
                        id="poNumberField"
                        formControlName="poNumber"
                        placeholder="{{'basket.orderInformation.poNumber.placeholder' | translate}}"/>
                <ng-template #noNumberRole>
                <div class="poNumber-only-view">
                    {{model.orderHistory?.purchaseOrderNumber ? model.orderHistory?.purchaseOrderNumber : ('basket.orderInformation.poNumber.noData' | translate)}}
                </div>
                </ng-template>

            </div>
            <div class="spacer"></div>
            <div class="note">
                <div class="label">
                    <label>{{'basket.orderInformation.poNote.headline' | translate}}</label>
                </div>
                <textarea
                        id="note"
                        formControlName="poNote"
                        placeholder="{{'basket.orderInformation.poNote.placeholder' | translate}}"
                ></textarea>
            </div>
        </div>
    </div>
</div>
